var exports = {
  "Vf": "MessageReactions.module__reactionsGrid___YkxIQm",
  "RW": "MessageReactions.module__reactionContainer___YkxIQm",
  "sU": "MessageReactions.module__reactionButton___YkxIQm",
  "I1": "MessageReactions.module__reactionMe___YkxIQm",
  "iX": "MessageReactions.module__reactionInner___YkxIQm",
  "Zg": "MessageReactions.module__emoji___YkxIQm",
  "Ps": "MessageReactions.module__countWrapper___YkxIQm",
  "lG": "MessageReactions.module__reactionContainerDisabled___YkxIQm",
  "II": "MessageReactions.module__reactionButtonDisabled___YkxIQm",
  "Go": "MessageReactions.module__reactionPickerButton___YkxIQm",
  "SD": "MessageReactions.module__reactionPickerButtonActive___YkxIQm",
};

module.exports = exports;
